import React from 'react';
import './index.css';
import styled from 'styled-components/macro';
import propTypes from 'prop-types';

/**
 *    Migas de navegación accesibles. Cada hijo que se le pase será
 *    un elemento <li> de una <ol>. Se le puede pasar un separador
 *    entre elementos y se debe pasar un aria-label que describa al componente
 *
 */
//Referencia
//https://www.w3.org/TR/wai-aria-practices/examples/breadcrumb/index.html
//https://www.w3.org/WAI/GL/wiki/Using_HTML5_nav_element

//Ejemplo de implementación
//https://material-ui.com/components/breadcrumbs/
const Breadcrumbs = React.forwardRef(function Breadcrumbs(
  { children, separator = '/', 'aria-label': ariaLabel, esHistorico, ...other },
  ref
) {
  const last = React.Children.count(children) - 1;
  return (
    <nav aria-label={ariaLabel} ref={ref} role="navigation" {...other}>
      <ol className="breadcrumbs-list">
        {React.Children.map(children, (x, index) => {
          return last !== index ? (
            <>
              <li
                key={index}
                className="breadcrumbs-item"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {!esHistorico ? (
                  <>
                    {x}{' '}
                    <SeparatorContainer esHistorico={esHistorico}>
                      {separator}
                    </SeparatorContainer>
                  </>
                ) : (
                  <>
                    {x}{' '}
                    <SeparatorContainer esHistorico={esHistorico}>
                      {'>'}
                    </SeparatorContainer>
                  </>
                )}
              </li>
            </>
          ) : (
            <li key={index} aria-current="page" className="breadcrumbs-item">
              {x}
            </li>
          );
        })}
      </ol>
    </nav>
  );
});

export default Breadcrumbs;

Breadcrumbs.propTypes = {
  'aria-label': propTypes.string.isRequired,
  children: propTypes.node.isRequired,
};

const SeparatorContainer = styled(({ esHistorico, ...rest }) => (
  <div {...rest} />
))`
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 10px;
  font-size: 13px;
  display: ${({ esHistorico }) => (esHistorico ? 'block' : 'none')};
  line-height: 21px;
  @media (max-width: 768px) {
    display: block;
    line-height: 26px;
  }
`;
